import * as React from 'react';
import { cn } from '@/lib/cn';

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      'block w-full h-10 rounded-[var(--radius-input)] border-0 bg-bg px-3 text-sm text-text outline-1 -outline-offset-1 outline-border',
      'focus:outline-2 focus:-outline-offset-2 focus:outline-accent appearance-none',
      'bg-[image:linear-gradient(45deg,transparent_50%,currentColor_50%),linear-gradient(135deg,currentColor_50%,transparent_50%)]',
      'bg-[length:5px_5px,5px_5px] bg-[position:calc(100%-15px)_55%,calc(100%-10px)_55%] bg-no-repeat',
      'pr-9',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    {...props}
  >
    {children}
  </select>
));
Select.displayName = 'Select';
